export function PageLoader() {
  return (
    <div className="space-y-6 p-6 animate-pulse" role="status">
      <span className="sr-only">Загрузка…</span>
      <div aria-hidden="true">
        <div className="space-y-2">
          <div className="h-8 w-48 rounded-md bg-[var(--surface-2)]" />
          <div className="h-3 w-64 rounded-md bg-[var(--surface-2)] opacity-70" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-32 rounded-md bg-[var(--surface-2)]"
              style={{ animationDelay: `${i * 80}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
